import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import Headstu from '../components/Header';
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL,timestamp } from '../common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Typography, CardContent, CardHeader, Avatar, Grid, Box, Container, Card } from '@mui/material';
import TextField from '@mui/material/TextField';
import bcrypt from 'bcryptjs';
import { decryptData } from '../Axiosinstance';

const Newbatch = () => {
  const [userData, setUserData] = useState({
    id: '',
    username: '',
    password: '',
    email: '',
    usertype: 0,
    sfid: 0,
    profile_Url: '',
    name: ''
  });

  const [uploadedFileUrl, setUploadedFileUrl] = useState('');
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [oldpassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [initialUserData, setInitialUserData] = useState(null);

  useEffect(() => {
    // Retrieve the id from local storage
    const id = decryptData(localStorage.getItem('userId'));

    if (id) {
      // Make an API request to get user data
      axios.get(`/home/user/${id}`)
        .then((response) => {
          const userDataResponse = response.data;
          // Update the state with the response data
          setUserData(userDataResponse);
          setInitialUserData(userDataResponse);
        })
        .catch((error) => {
          console.error('Error fetching user data:', error);
        });
    }
  }, []);

  const hasChanges = JSON.stringify(userData) !== JSON.stringify(initialUserData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };



  const handleFileUpload = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
      formData.append('public_id', 'LMS/profile/' + file.name +' - '+ timestamp);

      try {
        const response = await fetch(baseURL, {
          method: 'POST',
          body: formData,
        });
        const data = await response.json();
        if (data.secure_url !== '') {
          const url = data.secure_url;
          setUploadedFileUrl(url);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  // Function to handle saving changes
  const handleSaveChanges = () => {
    console.log(userData.userId)
    // Make a PUT request to update user details
    axios
      .put(`/home/user/${userData.userId}`, {
        ...userData,
        profile_Url: uploadedFileUrl || userData.profile_Url, // Use the uploadedFileUrl if available, else retain the existing URL
      })
      .then((response) => {
        // Handle success, e.g., show a success message
        // console.log('User details updated:', response.data);
        toast.success('User details updated successfully!', {
          position: 'bottom-right',
          autoClose: 3000, // Close the toast after 3 seconds
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      })
      .catch((error) => {
        // Handle errors, e.g., show an error message
        console.error('Error updating user details:', error);
        toast.error('Error updating user details. Please try again.', {
          position: 'bottom-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
      });
  };

  const handleChangePassword = async () => {
    if (!oldpassword.trim() || !newPassword.trim()) {
      setErrorMessage("Both fields are required.");
      return;
    }
    // Check if the old password matches the stored hashed password
    const isMatch = await bcrypt.compare(oldpassword, userData.password);

    if (isMatch) {
      // Hash the new password
      const salt = await bcrypt.genSalt(10);
      const hashedNewPassword = await bcrypt.hash(newPassword, salt);

      // Create an updated user data object
      const updatedUserData = {
        ...userData, // spread existing user data
        password: hashedNewPassword, // replace the old password with the new hashed password
      };

      console.log('Updated user data:', updatedUserData); // Log the updated user data

      // Make a PUT request to update user details
      axios.put(`/home/user/${userData.userId}`, updatedUserData)
        .then(response => {
          toast.success('User details updated successfully!', {
            position: 'bottom-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });

          // Close the modal after successful update
          setModalOpen(false);

          // Clear the modal input fields
          setOldPassword('');
          setNewPassword('');
          setErrorMessage('');

        })
        .catch(error => {
          console.error('Error updating user details:', error);
          toast.error('Error updating user details. Please try again.', {
            position: 'bottom-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          });
        });
    } else {
      setErrorMessage('Old password is incorrect.');
    }
  };



  return (
    <Container maxWidth="md" >
      <Box my={4} style={{ width: '100%' }}>
        <Typography variant="h4" gutterBottom align="left" style={{ marginBottom: '20px' }}>
          <Link to="/profile" style={{ textDecoration: 'none', color: '#3f51b5', fontWeight: 'bolder' }}>Profile</Link>
        </Typography>
        <Card elevation={3} style={{ padding: '20px' }}>
          <CardHeader
            title="Account Details"
            avatar={<Avatar src={userData.profile_Url} alt="Profile" />}
            titleTypographyProps={{ variant: 'h6', align: 'left' }}
            style={{ textAlign: 'left' }}
          />
          <CardContent>
            <form>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Username"
                    name="name"
                    value={userData.name}
                    onChange={handleInputChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Email"
                    name="email"
                    type="email"
                    value={userData.email}
                    onChange={handleInputChange}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <label htmlFor="fileupload" style={{ fontWeight: 'bold' }}>Upload Profile Image</label>
                  <input type="file" id="fileupload"
                    onChange={(event) => {
                      const file = event.target.files[0];
                      if (file && file.size > 8 * 1024 * 1024) {
                        event.target.value = ""; // Reset file input
                        alert("File size must be less than 8MB.");
                      } else {
                        handleFileUpload(event);
                      }
                    }}
                    style={{ marginTop: '10px', display: 'block' }} />
                  {userData.profile_Url && (
                    <Box mt={2} textAlign="center">
                      <img src={userData.profile_Url} alt="Profile" style={{ width: '150px', height: '150px', borderRadius: '50%' }} />
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Box mt={3} textAlign="center">
                <div className="d-flex-center">
                  <button
                    type="button"
                    style={{ backgroundColor:"#007bff" }}
                    className="btn "
                    onClick={() => setModalOpen(true)}
                  >
                    Change Password
                  </button>
                  <button
                    type="button"
                    style={{ backgroundColor:"green" }}
                    // disabled={!hasChanges}
                    className="btn "
                    onClick={handleSaveChanges}
                  >
                    Save Changes
                  </button>
                </div>

              </Box>
            </form>
          </CardContent>
        </Card>

        <Modal centered show={modalOpen} onHide={() => setModalOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Change Password</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TextField
              label="Old Password"
              type="password"
              fullWidth
              value={oldpassword}
              onChange={(e) => setOldPassword(e.target.value)}
              margin="normal"
              variant="outlined"
            />
            {errorMessage && <Typography color="error">{errorMessage}</Typography>}
            <TextField
              label="New Password"
              type="password"
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              margin="normal"
              variant="outlined"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button style={{ backgroundColor:"#007bff" }} onClick={() => setModalOpen(false)}>
              Close
            </Button>
            <Button  disabled={!oldpassword.trim() || !newPassword.trim()}   style={{ backgroundColor:"green" }} onClick={handleChangePassword}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
      <ToastContainer />
    </Container>

  );
};

const NewbatchPage = () => {
  return (
    <div>
      <Headstu />

      <Newbatch />

    </div>
  );
};

export default NewbatchPage;
